module.exports = __webpack_public_path__ + "img/forest.7b6e27eb.svg";